export default __webpack_public_path__ + "static/media/pitney-bowes-logo.cabfb97e.png";